import Vue from 'vue';

export default class DefaultClientActionsActions {
    constructor(resource, organisationCode, customConfig) {
        this.resource = resource;
        this.organisationCode = organisationCode;
        this.customConfig = customConfig;
    }

    updateDisplayOrder(actionsDisplayOrder) {
        return Vue.prototype.$axiosMainClient.post(
            `organisations/${this.organisationCode}/${this.resource}/displayorder`, actionsDisplayOrder,
            this.customConfig
        );
    }

}
